import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import ReorderIcon from '@mui/icons-material/Reorder';
import {
    Box,
    Divider,
    IconButton,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const SortableItem = ({ canModify, companyCatalog, prepareUpdate, type }) => {
    return (
        <Box>
            <Box>
                <ListItemButton>
                    <ListItemIcon>
                        <ReorderIcon fontSize="small" />
                    </ListItemIcon>

                    <ListItemText primary={companyCatalog.name} />

                    {canModify && (
                        <IconButton
                            onClick={() => prepareUpdate(companyCatalog, type)}
                            sx={{ ml: 'auto' }}
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    )}
                </ListItemButton>
                <Divider />
            </Box>
        </Box>
    );
};

SortableItem.propTypes = {
    canModify: PropTypes.bool,
    companyCatalog: PropTypes.object,
    prepareUpdate: PropTypes.func,
    type: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
};

export default SortableItem;
